import { createPageSegmentLoadMetric } from '@confluence/browser-metrics/entry-points/metricConfigs.ts';
import { MEDIA_SEGMENT_KEY } from '@confluence/browser-metrics/entry-points/metric-keys.ts';

export const MEDIA_METRIC = createPageSegmentLoadMetric({
	key: MEDIA_SEGMENT_KEY,
});
